import React from 'react';
import { Divider, Typography } from 'antd';
import '../../../Styles/ResearchLabs.css';

const { Title } = Typography;

const teamMembers = [
  ['Dr. Saeeda Sajjad', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-01.jpg')],
  ['Dr. Imran Ali Khan', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-02.png')],
  ['Dr. Asad Ali', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-03.jpg')],
  ['Dr. Kabir Khan', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-04.png')],
  ['Dr. M Usman', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-05.jpg')],
  ['Dr. Hamid Saleem', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-06.jpg')],
  ['Dr. Fazeel Mahmood Khan', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-07.jpg')],
  ['Dr. Rana Usman Ali', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-08.jpg')],
  ['Dr. Ahmad Waqas Zubairi', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-09.jpg')],
  ['Mr. Abdullah Waqar', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-10.jpg')],
  ['Mr. Junaid Iqbal', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-11.png')],
  ['Mr. Syed Mohsin Ali Bukhari', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-12.jpg')],
  ['Ms. Shanza Urooj', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-13.jpg')],
  ['Ms. Urooba Shaikh', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-14.jpg')],
  ['Mr. Ismael Khan', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-15.jpg')],
  ['Ms. Aiza Jabeen', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-16.jpg')],
  ['Nazeela Aimen', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-17.jpg')],
  ['Zarnigah Kiyani', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-18.jpg')],
  ['Zunaira Shafiq', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-19.jpg')],
  ['Fiza Javed', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-20.jpg')],
  ['Mr. Muhammad Junaid', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-21.jpg')],
  ['Mr. Gohar Shafi', require('../../../Assets/ResearchLabs/SARL/Team/SARL-Team-22.jpg')],
];

const OurTeam = () => (
  <section className="sarl-team-section">
    <div className="sarl-team-inner">
      <Title level={2} className="sarl-team-title">Our Team</Title>
      <Divider className="ncgsa-divider" />

      <div className="sarl-team-grid">
        {teamMembers.map(([name, image]) => (
          <article className="sarl-team-member" key={name}>
            <img src={image} alt={name} className="sarl-team-photo" />
            <h3>{name}</h3>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default OurTeam;
